var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsOutCardinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9887 14.3238L9 16.3125M9 16.3125L7.01128 14.3238M9 16.3125V11.25M3.67622 10.9887L1.6875 9M1.6875 9L3.67622 7.01128M1.6875 9H6.75M14.3238 7.01128L16.3125 9M16.3125 9L14.3238 10.9887M16.3125 9H11.25M7.01128 3.67622L9 1.6875M9 1.6875L10.9887 3.67622M9 1.6875V6.75",
    stroke: "#541FF3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsOutCardinal);
export default __webpack_public_path__ + "static/media/ArrowsOutCardinal.f67e5d94ac2a351d537daeab4894ba0b.svg";
export { ForwardRef as ReactComponent };